/**
 * 日期转换成毫秒
 * @param dateStr
 * @returns {number}
 */
export function getTimeFromString(dateStr) {
    return new Date(dateStr).getTime()
}

const DateTimeField = {
    "Year": 0,
    "Month": 1,
    "Day": 2,
    "Hour": 3,
    "Minute": 4,
    "Second": 5
}

const DateShortCut = {
    "Week": 0,
    "Month": 1,
    "ThreeMonth": 2,
}

export {DateTimeField,DateShortCut}

/**
 * 时间加减操作
 * @param time 毫秒时间
 * @param dateTimeField 要加哪个字段
 * @param value 加多少
 */
export function addDateTime(time, dateTimeField, value) {
    let date = new Date(time)
    // console.log(`addDateTime in ${date}`)
    switch (dateTimeField) {
        case DateTimeField.Year:
            date.setFullYear(date.getFullYear() + value)
            break;
        case DateTimeField.Month:
            date.setMonth(date.getMonth() + value)
            break;
        case DateTimeField.Day:
            date.setDate(date.getDate() + value)
            break;
        case DateTimeField.Hour:
            date.setHours(date.getHours() + value)
            break;
        case DateTimeField.Minute:
            date.setMinutes(date.getMinutes() + value)
            break;
        case DateTimeField.Second:
            date.setSeconds(date.getSeconds() + value)
            break;
    }
    // console.log(`addDateTime out ${date}`)
    return date.getTime()
}

Date.prototype.format = function(fmt) {
    var o = {
        "M+" : this.getMonth()+1,                 //月份
        "d+" : this.getDate(),                    //日
        "h+" : this.getHours(),                   //小时
        "H+" : this.getHours(),                   //小时
        "m+" : this.getMinutes(),                 //分
        "s+" : this.getSeconds(),                 //秒
        "q+" : Math.floor((this.getMonth()+3)/3), //季度
        "S"  : this.getMilliseconds()             //毫秒
    };
    if(/(y+)/.test(fmt)) {
        fmt=fmt.replace(RegExp.$1, (this.getFullYear()+"").substr(4 - RegExp.$1.length));
    }
    for(var k in o) {
        if(new RegExp("("+ k +")").test(fmt)){
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
        }
    }
    return fmt;
}